import styled from 'styled-components';

export const OnboardingFooterContainerStyles = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 500px;
`;

export const BubbleImageStyles = styled.img`
  position: fixed;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 250px;
  height: 166px;
  z-index: 1;
`;

export const TextContainerStyles = styled.div`
  margin-bottom: 12px;

  @media (min-height: 800px) and (max-height: 840px) {
    margin-bottom: 16px;
  }

  @media (min-height: 840px) {
    margin-bottom: 32px;
  }
`;
